<script lang="ts">
	import { IconButton, Input } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';

	export let additionalContainerClass = '',
		minusFunction, // bind
		plusFunction, // bind
		additionalButtonAttributes: { disabled?: boolean } = {}, // Add type for additionalButtonAttributes
		additionalInputAttributes = {},
		additionalInputClass = '',
		label = '',
		info = '', // bind
		value, // bind
		error, // bind
		inputHandler, // bind
		disabledMinusBtn = false,
		disabledPlusBtn = false,
		inputId = `dynamic-input-${Math.random().toString(36).substr(2, 9)}`;

	$: minusButtonAttributes = {
		...additionalButtonAttributes,
		disabled: additionalButtonAttributes.disabled || disabledMinusBtn,
	};

	$: plusButtonAttributes = {
		...additionalButtonAttributes,
		disabled: additionalButtonAttributes.disabled || disabledPlusBtn,
	};
</script>

<div class={`d-flex ${additionalContainerClass}`}>
	<IconButton
		icon="fas fa-minus"
		aria-label={$format('button_decrease_value', {
			default: 'Decrease value',
		})}
		on:click={minusFunction}
		{...minusButtonAttributes}
	/>
	<Input
		class="width-md-s width-sm-full ml-s mr-s {additionalInputClass}"
		type="number"
		size="m"
		id={inputId}
		aria-label={$format('input_numeric_value', {
			default: 'Numeric value',
		})}
		{value}
		{info}
		{error}
		{label}
		on:input={(e) => inputHandler(e)}
		{...additionalInputAttributes}
	/>
	<IconButton
		icon="fas fa-plus"
		aria-label={$format('button_increase_value', {
			default: 'Increase value',
		})}
		on:click={plusFunction}
		{...plusButtonAttributes}
	/>
</div>
